// 가입시 무료 5회 이용권 발급
// 1. 가입 후 14일 이내
// 2. 구매내역 없슴
// 3. 쿠폰발급가능

import {
  Card,
  CardContent,
  Box,
  Paper,
  Badge,
  Typography,
  Dialog,
  Button,
  Divider,
  ThemeProvider,
} from "@mui/material";
import pr from "../lib/pr";
import { useEffect, useState } from "react";
import { configState } from "../lib/State";
import axios from "axios";
import get_token from "../lib/get_token";
import Swal from "sweetalert2";
import { createTheme } from "@mui/material/styles";
import get_cid from "../lib/get_cid";
import { useHistory, Link } from "react-router-dom";
import add_comma from "../lib/add_comma";

const btnTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            background: "#e4007f",
            color: "white",
            border: "none",
          },
        },
      },
    },
  },
});

function EventCoupon(props) {
  const { login, homeClassCouponReload, loaded } = props;
  const token = get_token();
  const [coupon, setCoupon] = useState(false);
  const cid = get_cid();
  const history = useHistory();

  // 지점별 체험쿠폰 수 변경
  // let free_coupon_count = 3;
  // if(cid === 'CID00000019' || cid === 'CT17X10111035.huwy5') {
  //   free_coupon_count = 1;
  // }

  // 웰컴쿠폰 로드
  const load_data = async () => {
    console.log('load_data');
    let data = {
      token: token || "",
      mcd: login.mcd || "",
      level: login.level || "",
      cid: cid || "",
    };

    const result = await axios.post(
      // configState.api + "/gympass/get_welcome_coupon", // 웰컴쿠폰
      configState.api + "/gympass/get_trial_coupon", // 체험쿠폰
      data
    );
    if (result.data.success === 1) {
      setCoupon(true);
    }
    else {
      console.log('error==>', result?.data);
    }
  };

  const onCouponClick = async () => {
    if (login.mcd === "") {
      await Swal.fire({
        title: "안내",
        text: "로그인 및 회원가입 후 이용해주세요."
      })
      return
    }

    // 구매페이지 이동
    // history.push("/buy");
    let postData = {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/gympass/join_coupon_issue",
      postData
    );
    if (result.data.success === 1) {
      Swal.fire({
        title: "체험쿠폰 발급 완료",
        html: `체험쿠폰 (유효기간 7일) <br />이 발급되었습니다. <br />
        클래스를 예약 후 이용하세요.`,
      });
      setCoupon(false);
      homeClassCouponReload();
    } else {
      Swal.fire("쿠폰발급 오류");
    }
  };

  useEffect(() => { // 로그인 상태에서 쿠폰확인
    if(login && login.mcd) {
      load_data();
    }    
  }, [login]);

  return (
    <>
      {/* 문래점 종료 */}
      {cid && cid === "CID00000018" && (
        <div className="flex justify-center">
          <div className="border-2 rounded-lg w-[80%] p-[10px] mt-[30px] bg-gray-100">
            <div className="font-bold text-[18px]">두써킷센터 문래점 운영 종료 안내</div>
            <div className="mt-1">그동안 감사했습니다.</div>
            <div>저희 두써킷 문래점 영업일이 3월 13일로 종료될 예정입니다. </div>
            <div>재등록 시 참고해 주세요.</div>
          </div>
        </div>)}

      { /* 무료체험쿠폰 - 로그아웃 상태 */}
      {cid && (cid === "CID00000009"|| cid==="CT17X10111035.huwy5") && !login.mcd && loaded ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 1 }}
        >
          <Paper
            // variant="outlined"
            sx={{
              width: "90%",
              borderRadius: 2,
              backgroundImage: `url(${"/img/free_coupon_no_round.jpg"})`,
              backgroundSize: "cover",
              marginTop: "20px",
              height: "195px",
            }}
          >
            <Box sx={{ m: 2, color: "white" }}>
              <Box
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                신규 회원 웰컴 이벤트
                <br />
                무료 쿠폰을 받으세요!
              </Box>
              <Box
                sx={{
                  fontSize: "15px",
                  marginTop: "2px",
                  fontWeight: "bold"
                }}
              >
                지금 신규 가입하시면
                <br></br>
                클래스 체험 1회권을 드립니다.
              </Box>
              <Box sx={{ height: 40 }}></Box>
            </Box>
          </Paper>
        </Box>
      ) : null}

      { /* 무료체험쿠폰 - 다운 가능할때 */}
      { cid && (cid === "CID00000009"|| cid==="CT17X10111035.huwy5") && login.mcd && coupon && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 1 }}
        >
          <Paper
            // variant="outlined"
            sx={{
              width: "90%",
              borderRadius: 2,
              backgroundImage: `url(${"/img/free_coupon_no_round.jpg"})`,
              backgroundSize: "cover",
              marginTop: "20px",
              minHeight: "195px",
            }}
          >
            <Box sx={{ m: 2, color: "white" }}>
              <Box
                sx={{
                  fontSize: "22px",
                  fontWeight: "bold",
                }}
              >
                <Box>
                  신규 회원 웰컴 이벤트
                </Box>
                <Box sx={{ mt: '-1', fontSize: '22px', fontWeight: 'bold' }}>
                  무료 쿠폰을 받아가세요!
                </Box>
              </Box>
              <Box
                sx={{
                  fontSize: "15px",
                  marginTop: "2px",
                }}
              >
                지금 신규가입 하시면
                <br></br>
                클래스 체험 1회 이용권을 드립니다.
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  position: 'relative',
                  width: '83px',
                  height: '50px'
                }}
              >
                <img src="/img/class_free.png?v=0427" />
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#e4007f',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}>
                  Class Coupon
                </Box>
                <ThemeProvider theme={btnTheme}>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      marginLeft: "5px",
                      borderRadius: "0",
                      border: "1px solid black",
                      background: "white",
                      color: "black",
                      minWidth: '100px',
                      width: '100px'
                      // '&:hover': { color: 'white', bakcgroundColor: '#e4007f'}
                    }}
                    onClick={onCouponClick}
                  >
                    쿠폰 받기
                  </Button>
                </ThemeProvider>
              </Box>

              {/* <Box sx={{ height: 40 }}></Box> */}
              {/* <Box>
              <Button onClick={onCouponClick}>쿠폰받기</Button>
            </Box> */}
            </Box>
          </Paper>
        </Box>)}


      { /* 3회 웰컴 이벤트  */}
      {false && ( //loaded && cid === "CID00000009" && coupon?.active === 'Y' && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 1 }}
        >
          <Paper
            // variant="outlined"
            sx={{
              width: "90%",
              borderRadius: 2,
              backgroundImage: `url(${"/img/free_coupon_no_round.jpg"})`,
              backgroundSize: "cover",
              marginTop: "20px",
            }}
          >
            <Box sx={{ m: 2, color: "white" }}>
              <Box
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
              >
                <div>신규회원 대상 웰컴 3회 이벤트!</div>
                <div className="bg-[#e11111] py-1 inline-block px-3 rounded-full text-[1rem] border-2">
                  쿠폰 유효기간 {coupon?.day}일 / {add_comma(coupon?.cash)}캐시지급
                </div>
              </Box>
              <Box
                sx={{
                  fontSize: "15px",
                  marginTop: "3px",
                  fontWeight: "bold",
                }}
                className="leading-tight"
              >
                {
                  coupon?.comment?.map((v, i) => (
                    <div>{v}</div>
                  ))
                }

              </Box>
              <ThemeProvider theme={btnTheme}>
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    marginLeft: "5px",
                    borderRadius: "0",
                    border: "1px solid black",
                    background: "white",
                    color: "black",
                    minWidth: "100px",
                    width: "100px",
                    marginTop: "0.5rem",
                    // '&:hover': { color: 'white', bakcgroundColor: '#e4007f'}
                  }}
                  onClick={onCouponClick}
                >
                  쿠폰구매
                </Button>
              </ThemeProvider>
            </Box>
          </Paper>
        </Box>)
      }

    </>
  );
}

export default EventCoupon;
